export default function schemaPriceRange(priceRange) {
  if (!priceRange) return "";

  const definitions = {
    "top-end": "$$$",
    "mid-range": "$$",
    budget: "$",
  };

  return definitions[priceRange] || "";
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schemaPriceRange.js